import { render, staticRenderFns } from "./insuranceOrder-info.vue?vue&type=template&id=f86d395e&scoped=true"
import script from "./insuranceOrder-info.vue?vue&type=script&lang=js"
export * from "./insuranceOrder-info.vue?vue&type=script&lang=js"
import style0 from "./insuranceOrder-info.vue?vue&type=style&index=0&id=f86d395e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f86d395e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f86d395e')) {
      api.createRecord('f86d395e', component.options)
    } else {
      api.reload('f86d395e', component.options)
    }
    module.hot.accept("./insuranceOrder-info.vue?vue&type=template&id=f86d395e&scoped=true", function () {
      api.rerender('f86d395e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/intercity/components/insuranceOrder-info.vue"
export default component.exports